import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './core/guards/auth.guard';
import {LoginGuard} from './core/guards/login.guard';
import {LoginPhoneGuard} from './core/guards/loginPhone.guard';

const routes: Routes = [
  {
    path: 'start',
    loadChildren: () => import('./pages/start/page.module').then(m => m.StartPageModule)
  },
  {
    path: 'blank',
    loadChildren: () => import('./pages/blank/page.module').then(m => m.BlankPageModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'authentication/phone',
    loadChildren: () => import('./pages/authentication/phone/page.module').then(m => m.PhonePageModule),
    canActivateChild: [LoginGuard]
  },
  {
    path: 'authentication/login',
    loadChildren: () => import('./pages/authentication/login/page.module').then(m => m.LoginPageModule),
    canActivateChild: [LoginGuard, LoginPhoneGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/page.module').then(m => m.DashboardPageModule),
    canActivateChild: [AuthGuard],
    data: {
      menuTitle: 'Дашборд',
      menuIcon: 'dash-dropmenu',
      menuGroup: 'prefix',
      menuOrder: 1,
    }
  },
  {
    path: 'workers',
    loadChildren: () => import('./pages/workers/page.module').then(m => m.WorkersPageModule),
    canActivateChild: [AuthGuard],
    data: {
      menuTitle: 'Сотрудники',    // Заголовок пункта в боковом меню. Если не указан - в меню не отобразится.
      menuIcon: 'emploees-dropmenu',        // название иконки из папки assets.
      menuGroup: 'activity',      //
      menuOrder: 4,               // чем меньше, тем выше по списку (внутри своей категории).
      permission: 'pwaWorkerList',
    }
  },
  {
    path: 'inventory',
    loadChildren: () => import('./pages/inventory/page.module').then(m => m.InventoryPageModule),
    canActivateChild: [AuthGuard],
    data: {
      menuTitle: 'ТМЦ',
      menuIcon: 'values-dropmenu',
      menuGroup: 'personal',
      menuOrder: 1,
      permission: 'viewOwnUniform',
    }
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/page.module').then(m => m.ProfilePageModule),
    canActivateChild: [AuthGuard],
    data: {
      permission: 'updateOwnWorksheet'
    }
  },
  {
    path: 'directory',
    loadChildren: () => import('./pages/directory/page.module').then(m => m.DirectoryPageModule),
    canActivateChild: [AuthGuard],
    data: {
      menuTitle: 'Штрафы, премии, нарушения',
      menuIcon: 'finesbonuses-dropmenu',
      menuGroup: 'handbooks',
      menuOrder: 1,
      permission: 'pwaDirectory',
    }
  },
  {
    path: 'account',
    loadChildren: () => import('./pages/account/page.module').then(m => m.AccountPageModule),
    canActivateChild: [AuthGuard],
    data: {
      menuTitle: 'Личный счет',
      menuIcon: 'persaccount-dropmenu',
      menuGroup: 'finance',
      menuOrder: 1,
      permission: 'pwaPersonalBill',
    }
  },
  {
    path: 'documents',
    loadChildren: () => import('./pages/documents/page.module').then(m => m.DocumentsPageModule),
    canActivateChild: [AuthGuard],
    data: {
      menuTitle: 'Мои документы',
      menuIcon: 'docs-dropmenu',
      menuGroup: 'personal',
      menuOrder: 2,
      permission: 'viewOwnDocuments',
    }
  },
  {
    path: 'calendar',
    loadChildren: () => import('./pages/calendar/page.module').then(m => m.CalendarPageModule),
    canActivateChild: [AuthGuard],
    data: {
      menuTitle: 'Календарь',
      menuIcon: 'calendar-dropmenu',
      menuGroup: 'activity',
      menuOrder: 2,
      permission: 'viewCalendarEventsPWA',
    }
  },
  {
    path: 'indicators',
    loadChildren: () => import('./pages/indicators/page.module').then(m => m.IndicatorsPageModule),
    canActivateChild: [AuthGuard],
    data: {
      menuTitle: 'Мои показатели',
      menuIcon: 'indicators-dropmenu',
      menuGroup: 'personal',
      menuOrder: 3,
      permission: 'pwaIndicators',
    }
  },
  {
    path: 'accountable',
    loadChildren: () => import('./pages/accountable/page.module').then(m => m.AccountablePageModule),
    canActivateChild: [AuthGuard],
    data: {
      menuTitle: 'Подотчет',
      menuIcon: 'accountable-dropmenu',
      menuGroup: 'finance',
      menuOrder: 2,
      permission: 'pwaSubreport',
    }
  },
  {
    path: 'duties',
    loadChildren: () => import('./pages/functions/page.module').then(m => m.FunctionsPageModule),
    canActivateChild: [AuthGuard],
    data: {
      menuTitle: 'Функции',
      menuIcon: 'functions-dropmenu',
      menuGroup: 'handbooks',
      menuOrder: 3,
      permission: 'pwaFunctions',
    }
  },
  {
    path: 'positions',
    loadChildren: () => import('./pages/positions/page.module').then(m => m.PositionsPageModule),
    canActivateChild: [AuthGuard],
    data: {
      menuTitle: 'Должности',
      menuIcon: 'positions',
      menuGroup: 'handbooks',
      menuOrder: 2,
      permission: 'pwaPosts',
    }
  },
  {
    path: 'test',
    loadChildren: () => import('./pages/test/page.module').then(m => m.TestPageModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'uikit',
    loadChildren: () => import('./pages/uikit/page.module').then(m => m.UIKitPageModule)
  },
  // {
  //   path: 'test',
  //   loadChildren: () => import('./pages/test/page.module').then(m => m.TestPageModule),
  //   canActivateChild: [AuthGuard]
  // },
  {
    path: 'uikit',
    loadChildren: () => import('./pages/uikit/page.module').then(m => m.UIKitPageModule)
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'authentication',
    redirectTo: 'authentication/phone',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
